// components/ChipTooltip.tsx
"use client";
import React from "react";

type Props = {
  text: string;
  visible?: boolean;
  align?: "left" | "center" | "right";
  bg?: string;
  color?: string;
};

export default function ChipTooltip({
  text,
  visible = true,
  align = "left",
  bg = "#2B8CFF",
  color = "#fff",
}: Props) {
  const styles: Record<string, React.CSSProperties> = {
    wrap: {
      // position: "absolute",
      top: 0,
      left: align === "left" ? 0 : align === "center" ? "50%" : undefined,
      right: align === "right" ? 0 : undefined,
      transform: align === "center" ? "translateX(-50%)" : undefined,
      display: visible ? "flex" : "none",
      alignItems: "center",
      zIndex: 20,
      pointerEvents: "none",
    },
    bubble: {
      position: "relative",
      background: bg,
      color,
      fontSize: 11,
      lineHeight: 1.2,
      fontWeight: 600,
      padding: "8px 12px",
      borderRadius: 8,
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      // whiteSpace: "nowrap",
    },
    arrow: {
      width: 10,
      height: 10,
      background: bg,
      transform: "rotate(45deg)",
      position: "absolute",
      top: -5, // attach to top of bubble
      left: align === "left" ? 12 : align === "center" ? "50%" : undefined,
      right: align === "right" ? 12 : undefined,
      marginLeft: align === "center" ? -5 : undefined,
      boxShadow: "0 -1px 2px rgba(0,0,0,0.08)",
    },
  };

  return (
    <div role="tooltip" aria-live="polite" style={styles.wrap}>
      <div style={styles.bubble}>
        {text}
        <div style={styles.arrow} />
      </div>
    </div>
  );
}
